import axios from 'axios';
import { MarketId } from 'types/market-id.enum';
import { CustomerAssortmentFilter } from 'views/order-feed/types/customer-assortment-filter.enum';
import { CustomerAssortment } from 'views/order-feed/types/customer-assortment.type';
import { ProductAssortment } from 'views/order-feed/types/product-assortment.type';

// GET
// /ewosapi/v1/products/customer-assortment?siteErpId={siteErpId}&filter={filter}
export const getCustomerAssortment = async (
  siteErpId: string,
  filter: CustomerAssortmentFilter
): Promise<CustomerAssortment> => {
  const res = await axios.get<CustomerAssortment>('/ewosapi/v1/products/customer-assortment', {
    params: { siteErpId, filter },
  });
  return res.data;
};

// GET (deprecated)
// /ewosapi/v1/products/customerpreferredarticlesassortment/{marketId}/{customerNumber}/{siteErpId}
// Returns 2 collections of customer products with date ranges when they are valid for feed orders page. PreferredProducts - products listed in feed plan and to 10 products from most recent orders AvailableProducts - All products in assortment
/** @deprecated Use getCustomerAssortment. */
export const getProductAssortment = async (
  marketId: MarketId,
  customerNumber: string,
  siteErpId: string
): Promise<ProductAssortment> => {
  try {
    // return ProductAssortmentData;
    const res = await axios.get<ProductAssortment>(
      `/ewosapi/v1/products/customerpreferredarticlesassortment/${marketId}/${customerNumber}/${siteErpId}`
    );
    return res.data;
  } catch (error) {
    // TODO: REMOVE THIS WHEN customerpreferredarticlesassortment IS IN PROD
    return { availableProducts: [], preferredProducts: [] };
  }
};
